import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PRODUCT_DESCRIPTION_ELEMENT_CLASS_NAME } from '../../../constants';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import ProductDescription from './product_description';
import {get, isEmpty, flatMap} from 'lodash';

const terminator = (
  <RosettaFormattedMessage parentFilename={__filename}
    id="terminator"
    description="Terminating character for products"
    defaultMessage="."
  />
);

const toProductDescriptionSentence = (products) =>
  flatMap(products, ({ id, ...props }, i) => {
    const description = <ProductDescription key={id} {...props} />;
    return i === products.length - 1
      ? description
      : [
        description,
        <RosettaFormattedMessage parentFilename={__filename}
          key={`${id}-msg`}
          id="separator"
          description="Separator for two or more products"
          defaultMessage="; "
        />
      ];
  });

export default class ProductDescriptions extends Component {
  shouldComponentUpdate(nextProps) {
    return get(nextProps, 'content.products')
      !== get(this.props, 'content.products');
  }

  render() {
    const products = get(this.props, 'content.products');
    if (isEmpty(products)) {
      return null;
    }
    return (
      <div className={PRODUCT_DESCRIPTION_ELEMENT_CLASS_NAME}>
        {toProductDescriptionSentence(products)}
        {terminator}
      </div>
    );
  }
}

ProductDescriptions.propTypes = {
  content: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired
  })
};
